export function camelize (key) {
  const regExp1 = /(-|_|\.|\s)+(.)?/g
  const regExp2 = /(^|\/)([A-Z])/g

  return key.replace(regExp1, (match, separator, chr) => (chr ? chr.toUpperCase() : '')).replace(regExp2, (match) => match.toLowerCase())
}

export function camelizeJson (json) {
  var output

  if (Object.prototype.toString.apply(json) === '[object Object]') {
    output = {}
    for (var i in json) {
      let key = camelize(i)
      output[key] = camelizeJson(json[i])
    }
  } else if (Object.prototype.toString.apply(json) === '[object Array]') {
    output = []
    json.forEach(function (item) {
      output.push(camelizeJson(item))
    })
  } else {
    output = json
  }

  return output
}

export function dasherize (key) {
  const regExp1 = /([a-z\d])([A-Z])/g
  const regExp2 = /[ _]/g

  return key.replace(regExp1, '$1_$2').toLowerCase().replace(regExp2, '-')
}

export function dasherizeJson (json) {
  var output

  if (Object.prototype.toString.apply(json) === '[object Object]') {
    output = {}
    for (var i in json) {
      let key = dasherize(i)
      output[key] = dasherizeJson(json[i])
    }
  } else if (Object.prototype.toString.apply(json) === '[object Array]') {
    output = []
    json.forEach(function (item) {
      output.push(dasherizeJson(item))
    })
  } else {
    output = json
  }

  return output
}
